import { __assign } from "tslib";
export var defaultMetricContext = {
    isSupport: true,
    isPolyfill: false,
    isBounced: false,
    isCustom: false,
    type: 'perf',
};
export var initMetric = function (name, value) {
    return __assign({ name: name, value: value }, defaultMetricContext);
};
export var invokeGetOnce = function (cb) {
    var hasGetted = false;
    var invoke = function (params) {
        if (hasGetted)
            return undefined;
        // 如果执行后依旧未拿到，直接返回
        var value = cb && cb(params);
        if (!value)
            return undefined;
        // 标记【拿到过数据】并返回数据
        hasGetted = true;
        return value;
    };
    return [invoke];
};
export var buildSingleMetricPayload = function (singleMetric) { return ({
    ev_type: 'performance',
    payload: singleMetric,
}); };
//# sourceMappingURL=util.js.map